<template>
  <l-layout :layout="['xs12']" bottom-space>
    <l-data-table
      :filter-items="filterItems"
      :get-data-func="getUsers"
      :headers="userHeaders"
      @click:row="goDetails('readonly',$event.item)"
      clickable
      init-sort-by="name"
      ref="userList"
      selectable
      search-text="搜索用户姓名"
      title-text="登记用户列表"
      v-model="selected"
    >
      <!--<template slot="title">-->
      <!--<v-tabs height="64px">-->
      <!--<v-tab>教师用户</v-tab>-->
      <!--<v-tab>学生用户</v-tab>-->
      <!--<v-tab>合作用户</v-tab>-->
      <!--</v-tabs>-->
      <!--</template>-->
      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
          @delete="deleteUser(selected)"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-layout>
            <v-btn @click="deleteUser(item)" icon>
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
            <v-btn @click="unbindUser(item)" icon :disabled="item.openIds===''">
              <v-icon small>$vuetify.icons.lock</v-icon>
            </v-btn>
          </v-layout>
        </td>
      </template>
    </l-data-table>
    <l-dialog
      :auto-close="false"
      :disable-confirm="!userValid"
      :loading="userDialog.loading"
      @cancel="userDialog.activate = false"
      @confirm="addUser(userDialog.form)"
      hide-divider
      max-width="400px"
      title="新增用户"
      v-model="userDialog.activate"
    >
      <v-container class="pt-0" grid-list-md>
        <v-form ref="addUser" v-model="userValid">
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                :rules="$rules.required()"
                hint="必填"
                label="用户姓名"
                persistent-hint
                prepend-icon="$vuetify.icons.person"
                v-model="userDialog.form.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="$rules.required()"
                hint="必填"
                label="用户账号"
                persistent-hint
                prepend-icon="$vuetify.icons.loginId"
                v-model="userDialog.form.loginId"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="$rules.required()"
                hint="必填"
                label="用户密码"
                persistent-hint
                prepend-icon="$vuetify.icons.lock"
                type="password"
                v-model="userDialog.form.password"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                :rules="[$rules.requiredS(), v => v === userDialog.form.password || '两次密码输入不一致']"
                hint="必填"
                label="再次输入"
                persistent-hint
                prepend-icon="$vuetify.icons.lock"
                type="password"
                v-model="userDialog.form.passwordAgain"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </l-dialog>
  </l-layout>
</template>

<script>
import {time} from '../../../../ladmin/utils/time'

export default {
  name: 'UserBinding',
  data: () => ({
    userValid: false,
    selected: [],
    userDialog: {
      activate: false,
      form: {
        name: '',
        loginId: '',
        password: '',
        passwordAgain: ''
      },
      checkMessage: '',
      loading: false
    },
    floatingButton: false,
    moreActions: [
      {
        event: 'delete',
        label: '批量删除',
        icon: '$vuetify.icons.deleteAll'
      },
      // {
      //   event: 'bindGroup',
      //   label: '批量绑定用户组',
      //   icon: '$vuetify.icons.group'
      // },
      // {
      //   event: 'bindRole',
      //   label: '批量绑定角色',
      //   icon: '$vuetify.icons.role'
      // },
      // {
      //   event: 'export',
      //   label: '导出PDF',
      //   icon: '$vuetify.icons.description'
      // }
    ],
    filterItems: [
      {
        key: 'creationTime',
        value: {},
        label: '登记时间',
        type: 'duration',
        layout: ['xs12', 'sm4'],
        f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
        range: true
      },
      {
        prependIcon: '$vuetify.icons.person',
        key: 'loginId',
        value: '',
        label: '登录ID',
        type: 'input',
        layout: ['xs12', 'sm4'],
      },
      {
        prependIcon: '$vuetify.icons.phone',
        key: 'phone',
        value: '',
        label: '电话号码',
        type: 'input',
        layout: ['xs12', 'sm4'],
      },
    ],
    userHeaders: [
      {text: '用户姓名', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '用户账号', value: 'loginId', align: 'right', placeholder: 'N/A'},
      {text: '电话号码', value: 'phone', align: 'right', placeholder: 'N/A'},
      {text: '登记时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
      {text: '', value: '', align: 'right', width: '80px', sortable: false}
    ],
  }),
  methods: {
    msg (m) {
      console.log(m)
    },
    async unbindUser(user){
      let {res, close} = await this.$L.confirm({
        title: '确认解除该用户的微信绑定？',
        text: (user.name==='')?"用户姓名:N/A":"用户姓名:"+user.name,
        subText: "用户账号:"+user.loginId
      })
      if (res) {
        try {
          let res = await this.$store.dispatch('userAdmin/unbindUsers', user.loginId)
          if(res.data.status===1){
            this.$L.alert('success',{message:'解绑成功'})
            this.$refs.userList.refresh()
          }else{
            this.$L.alert('error',{message:'解绑失败,原因:'+res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
      }
      close()
    },
    async addUser ({name, loginId, password, passwordAgain}) {
      if (this.$refs.addUser && this.$refs.addUser.validate()) {
        this.$set(this.userDialog, 'loading', true)
        // console.log(this.userDialog.loading)
        try {
          let person = await this.$store.dispatch('userAdmin/setUser', {
            name,
            loginId,
            password,
          })

          this.$set(this.userDialog, 'activate', false)
          this.$refs.userList.refresh()
          this.$router.push({
            name: 'EditUser',
            params: {loginId: person.loginId},
            query: {id: person.id}
          })
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
        finally {
          this.userDialog.loading = false
        }
      }
    },
    openUserDialog () {
      this.userDialog = {
        activate: true,
        form: {
          name: '',
          loginId: '',
          password: '',
          passwordAgain: ''
        },
        checkMessage: ''
      }
      this.$refs.addUser.reset()
    },
    async deleteUser (user) {
      // console.log(user)
      let multiple = user instanceof Array
      if (!user) return
      if (multiple && user.length === 0) {
        this.$L.alert('success', {message: '未选中任何项'})
        return
      }
      let {res, close} = await this.$L.confirm({
        title: multiple ? '确认删除选中项目？' : '确认删除该用户？',
        text: multiple ? '' : user.name || `N/A(${user.loginId})`,
        subText: multiple ? user.map(u => u.name || `N/A(${u.loginId})`) : undefined,
      })
      if (res) {
        try {
          await this.$store.dispatch('userAdmin/deleteUsers', user)
          this.$L.alert('success', {message: '删除成功'})
          if (multiple) {
            this.selected = []
          }
          this.$refs.userList.refresh()
        }
        catch (e) {
          this.$L.alert('error', {message: e.message})
        }
      }
      close()
    },
    async getUsers ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('userAdmin/getUsers', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'name', value: search}
      })
    },
    goDetails (status, item, force) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        if (status === 'new') {
          this.$router.push({name: 'NewUser'})
        }
        else {
          this.$router.push({
            name: 'UserDetails',
            params: {loginId: item.loginId},
            query: {id: item.loginId, from: 'user'}
          })
        }
      }
    },
    // async getTypes () {
    //   await this.$store.dispatch('userAdmin/getGroups', {type: 'reg', all: true, save: true, useCache: true})
    // }
  },
  // activated () {
  //   this.getTypes()
  // }
}
</script>

<style scoped>

</style>
